

// import React, { Component } from 'react';
// import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
// import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
// import { LoginCallback, Security, SecureRoute } from '@okta/okta-react';
// import SigninWidget from './components/auth/SigninWidget';
// import GenerateSummary from './components/pages/GenerateSummary';
// import Feedback from './components/pages/Feedback';
// import Upload from './components/pages/Upload';

// const oktaAuth = new OktaAuth({
//   issuer: `${process.env.REACT_APP_OKTA_ISSUER}`,
//   clientId: `${process.env.REACT_APP_OKTA_CLIENT_ID}`,
//   redirectUri: window.location.origin + '/login/callback'
// });

// class App extends Component {

//   constructor(props) {
//     super(props);
//     this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
//       props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
//     };

//   }

//   render() {
//     return (
//       <Security oktaAuth={oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
//         <Route path="/" exact={true} component={SigninWidget} />
//         <Route path="/login/callback" component={LoginCallback} />
//         <SecureRoute path="/Generate-Summary" exact={true} component={GenerateSummary} />
//         <SecureRoute path="/Feedback" exact={true} component={Feedback} />
//         <SecureRoute path="/upload" exact={true} component={Upload} />
//       </Security>
//     );
//   }
// }

// const AppWithRouterAccess = withRouter(App);

// class RouterApp extends Component {
//   render() {
//     return (<Router><AppWithRouterAccess/></Router>);
//   }
// }

// export default RouterApp;

import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SigninWidget from "./components/auth/SigninWidget";
import GenerateSummary from './components/pages/GenerateSummary';
import Feedback from './components/pages/Feedback';
import Upload from './components/pages/Upload';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig";
import Anonymizer from "./components/pages/Anonymizer";

const App = () => {
  useEffect(() => {
    localStorage.setItem("historyListFlag", true);
    localStorage.setItem("historyCollapse", false);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Switch>
          <Route exact path="/" component={SigninWidget} />
          <Route path="/Generate-Summary" component={GenerateSummary} />
          <Route path="/Feedback" component={Feedback} />
          <Route path="/anonymizer" component={Upload} />
          <Route path="/data/anonymizer/:id" component={Anonymizer} />

        </Switch>
      </Router>
    </MsalProvider>
  );
};

export default App;